import { render, staticRenderFns } from "./StcvPD_Details.vue?vue&type=template&id=a97a3b0c"
import script from "./StcvPD_Details.vue?vue&type=script&lang=js"
export * from "./StcvPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports